import axios from "axios";
import { Toast } from "vant"; // 根据使用的 UI 库调整

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 从环境变量获取
  timeout: 1800000, // 请求超时
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 此处可添加全局请求逻辑，例如：
    // 1. 添加 token
    let token = localStorage.token;

    // 如果localStorage中没有token，尝试从URL参数中获取
    if (!token) {
      const urlParams = new URLSearchParams(window.location.search);
      const urlToken = urlParams.get('token');
      if (urlToken) {
        // 将URL中的token保存到localStorage
        localStorage.token = urlToken;
        token = urlToken;
      }
    }

    if (token) {
      config.headers["Authorization"] = token;
      config.headers["token"] = token;
    }

    // 2. 设置 Content-Type
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;

    // 根据后端约定处理业务逻辑
    // 示例：假设 code 200 表示成功，其他为错误
    if (res.code !== 200) {
      Toast.fail(res.msg || "系统错误");
      return Promise.reject(new Error(res.msg || "系统错误"));
    }

    return res;
  },
  (error) => {
    // HTTP 状态码错误处理
    let errMessage = "请求失败";

    if (error.response) {
      switch (error.response.status) {
        case 401:
          errMessage = "身份验证失败";
          // 可跳转到登录页
          break;
        case 403:
          errMessage = "拒绝访问";
          break;
        case 404:
          errMessage = "资源不存在";
          break;
        case 500:
          errMessage = "服务器错误";
          break;
      }
    }

    Toast.fail(errMessage);
    return Promise.reject(error);
  }
);

export default service;
